import { FooterStyles } from "./styles";
import { RiFacebookFill, RiLinkedinBoxFill  } from "react-icons/ri";
export function Footer() {

  const anoAtual = new Date()

    return (
      <FooterStyles>
        <footer className="container-fluid bg-footer footer">
          <ul>
            <li>
              <a href="https://www.facebook.com/adviceinformatica/" target="_blank" rel="noopener noreferrer">
                <RiFacebookFill  />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/advice-informatica/about/" target="_blank" rel="noopener noreferrer">
                <RiLinkedinBoxFill />
              </a>
            </li>
          </ul>
          <p>
            <span>Copyright</span> &copy; {anoAtual.getFullYear()} All rights Reserved.
          </p>
        </footer>
      </FooterStyles>
    );
  }